export default [
	{ title: 'Batch Title', field: 'batch_title' },
	{ title: 'Activity', field: 'activity_desc' },
];
